module.exports = __webpack_public_path__ + "img/about-raven.0af8dc94.jpeg";